module.exports = __webpack_public_path__ + "img/UTFRON-6.54991171.jpg";